import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { FiCalendar, FiClock, FiMapPin, FiTag } from "react-icons/fi";
import "./event-details.css";

export default function EventDetails({
  description,
  dateRange,
  time,
  location,
  tickets,
  poster,
}) {
  const mainRef = useRef(null);
  const sideRef = useRef(null);

  useEffect(() => {
    const els = [mainRef.current, sideRef.current].filter(Boolean);
    const observers = els.map((el, i) => {
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.style.transitionDelay = `${i * 0.15}s`; // Fixed syntax error here (* operator)
            el.classList.add("ed-visible");
            obs.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <section className="ed-wrap">
      <div className="ed-grid">

        {/* LEFT — Main Overview & Tickets */}
        <article className="ed-main ed-animate" ref={mainRef}>

          <div className="ed-block">
            <span className="ed-tag">OVERVIEW</span>
            <div className="ed-desc">{description}</div>
          </div>

          <div className="ed-divider" />

          <div className="ed-block">
            <span className="ed-tag">TICKETS &amp; ADMISSION</span>
            <p className="ed-ticket-note">
              Tickets are available in advance or onsite via <strong>KenyaBuzz</strong>.
            </p>
            
            <div className="ed-ticket-rows">
              {tickets && tickets.length > 0 ? (
                tickets.map((item, idx) => (
                  <div className="ed-ticket-row" key={idx}>
                    <FiTag className="ticket-icon" />
                    <span className="ed-ticket-price">{item}</span>
                  </div>
                ))
              ) : (
                <div className="ed-ticket-row">
                  <span className="ed-ticket-type">Daily Pass</span>
                  <span className="ed-ticket-price">
                    Adults <strong>Ksh 500</strong> &nbsp;|&nbsp; Under 18s <strong>Ksh 200</strong>
                  </span>
                </div>
              )}
            </div>

            <a
              className="ed-ticket-btn"
              href="https://kenyabuzz.com/events/event/bizarre-bazaar-festival-the-global-village-edition"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Tickets on KenyaBuzz
            </a>
          </div>

        </article>

        {/* RIGHT — Poster & Metadata Sidebar */}
        <aside className="ed-side ed-animate" ref={sideRef}>

          {poster && (
            <div className="ed-poster-wrap">
              <img
                src={poster}
                alt="Event Poster"
                className="ed-poster"
              />
            </div>
          )}

          <div className="ed-side-card">
            <div className="ed-meta-row">
              <div className="ed-meta-icon"><FiCalendar /></div>
              <div>
                <div className="ed-meta-label">When</div>
                <div className="ed-meta-value">{dateRange}</div>
              </div>
            </div>

            <div className="ed-meta-row">
              <div className="ed-meta-icon"><FiClock /></div>
              <div>
                <div className="ed-meta-label">Time</div>
                <div className="ed-meta-value">{time}</div>
              </div>
            </div>

            <div className="ed-meta-row">
              <div className="ed-meta-icon"><FiMapPin /></div>
              <div>
                <div className="ed-meta-label">Location</div>
                <div className="ed-meta-value">{location}</div>
              </div>
            </div>
          </div>

        </aside>
      </div>
    </section>
  );
}

EventDetails.propTypes = {
  description: PropTypes.node,
  dateRange: PropTypes.string,
  time: PropTypes.node,
  location: PropTypes.string,
  tickets: PropTypes.arrayOf(PropTypes.string),
  poster: PropTypes.string,
};

EventDetails.defaultProps = {
  description: "",
  dateRange: "",
  time: "",
  location: "",
  tickets: [],
  poster: null,
};